import { render } from "./ServTeam.vue?vue&type=template&id=302485f6"
import script from "./ServTeam.vue?vue&type=script&lang=js"
export * from "./ServTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__